import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@services';
import { Observable } from 'rxjs';
import { cloneAndAddHeaders, csdtAuthApp } from './lib.interceptors';

export const KeplerCoveoInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const urlToMatch = environment.api.kepler.coveo.url;
    const authService = inject(AuthService);

    if (urlToMatch && req.url.startsWith(urlToMatch)) {
        let headers: Record<string, string>;
        if (req.url.indexOf('authenticated-search-token') >= 1) {
            // only 1 endpoint requires auth
            headers = {
                Authorization: `Bearer ${authService.accessToken}`,
                'csdt-authorization-app': csdtAuthApp,
                'Content-Type': 'application/json',
            };
        } else {
            headers = {
                'Content-Type': 'application/json',
            };
        }
        const clone = cloneAndAddHeaders(req, headers);
        console.debug('[Interceptors][KeplerCoveoInterceptor] Modified request:', clone);
        return next(clone);
    } else {
        return next(req);
    }
};
